import { Modal } from "react-bootstrap";
import { useProfiles } from "../hooks/use-profiles.hook";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdOverview from "./adoverview";
import AdSetting from "./adsetting";

export default function AdProfile({ show, setShow }: { show: boolean, setShow: (value: boolean) => void }) {
    const [myProfile, setMyProfile] = useState<any>({});
    let [activeIndex, setActiveIndex] = useState(1)
    const { loadProfile } = useProfiles();

    useEffect(() => {
        const load = async () => {
            const profile = await loadProfile('me');
            setMyProfile(profile);
        }

        load();
    }, []);

    return (
        <Modal show={show} onHide={() => setShow(false)} size="xl">
            <Modal.Header>
                <h5>Admin Setting</h5>
            </Modal.Header>
            <Modal.Body>
                <div className="card rounded shadow overflow-hidden mt-4 border-0">
                    <div className="p-5 bg-primary bg-gradient"></div>
                    <div className="avatar-profile d-flex margin-nagative mt-n5 position-relative ps-3">
                        <img src={myProfile?.avatar?.[0]?.url ?? '/non-ava.png'}
                            className="avatar object-cover avatar-ex-small rounded-circle"
                            style={{
                                width: "120px",
                                height: "120px",
                                objectFit: "cover",
                            }}
                            alt="" />
                        <div className="mt-4 ms-3 pt-3">
                            <h5 className="mt-3 mb-1">{myProfile?.name ? myProfile.name : '(Do not have name)'}<br /><small className="text-muted">{myProfile?.expertise ? myProfile.expertise : '(Expertise not available)'}</small></h5>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 mt-4">
                            <div className="card border-0 rounded-0 p-4">
                                <ul className="nav nav-pills nav-justified flex-column flex-sm-row rounded shadow overflow-hidden bg-light">
                                    <li className="nav-item">
                                        <Link className={`${activeIndex === 1 ? 'active' : ''} nav-link rounded-0`} to="#" onClick={() => setActiveIndex(1)}>
                                            <div className="text-center pt-1 pb-1">
                                                <h5 className="mb-0">Overview</h5>
                                            </div>
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link className={`${activeIndex === 4 ? 'active' : ''} nav-link rounded-0`} to="#" onClick={() => setActiveIndex(4)} >
                                            <div className="text-center pt-1 pb-1">
                                                <h5 className="mb-0">Settings</h5>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>

                                <div className="tab-content mt-4" id="pills-tabContent">
                                    {activeIndex === 1 ?
                                        <AdOverview trainer={myProfile} /> : ""
                                    }
                                    {activeIndex === 4 ?
                                        <AdSetting trainer={myProfile} /> : ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}